import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import Cookies from 'js-cookie'
import { v4 as uuidv4 } from 'uuid'

import { API_HOST, ENDPOINTS, ROUTES, TOKEN_KEY } from './constants'

const api = axios.create({
  baseURL: `${API_HOST}`,
  withCredentials: false,
})

function isAuthPage() {
  if (typeof window === 'undefined') return false

  return (
    window.location.pathname === ROUTES.LOGIN.PATH ||
    window.location.pathname === ROUTES.REGISTER.PATH
  )
}

async function getToken() {
  if (typeof window !== 'undefined') {
    return Cookies.get(TOKEN_KEY)
  }

  const { cookies } = await import('next/headers')
  const cks = await cookies()
  return cks.get(TOKEN_KEY)?.value
}

async function setAuthorizationHeader(config: InternalAxiosRequestConfig) {
  if (config.headers.Authorization) return
  if (config.url === ENDPOINTS.AUTH.POST.LOGIN) return

  const token = await getToken()
  if (!token) return

  config.headers.Authorization = `Bearer ${token}`
}

function setRequestIdHeader(config: InternalAxiosRequestConfig) {
  if (config.headers['x-request-id']) return

  config.headers['x-request-id'] = uuidv4()
}

api.interceptors.request.use(
  async (config) => {
    setRequestIdHeader(config)
    await setAuthorizationHeader(config)
    return config
  },
  (error: AxiosError) => Promise.reject(error)
)

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (
      error.response?.status === 401 &&
      typeof window !== 'undefined' &&
      !isAuthPage()
    ) {
      window.location.href = ROUTES.LOGIN.PATH
    }

    return Promise.reject(error)
  }
)

export default api
